

const status_slices = {
    WAITING: 'waiting',
    PROCESSING: 'processing_request',
    LOADED: 'loaded',
    NOT_LOADED: 'not_loaded',
    ERROR: 'error',
    SUCCESS: 'success'
};


export { status_slices };